import React, {useState, useEffect } from 'react';
import { Button, Form } from 'react-bootstrap';
import FormGroup from '../forms/FormGroup'
import {useForm, Yup} from '../forms/form'
import { useTranslation } from 'react-i18next';
import { BoolSelect, Select } from '../components';
import FormRowCol from '../forms/FormRowCol';
import Icon from '../Icon';
import { inthertedValue } from './requestConfigUtils';

const formGroupWidthProps = {
  xs: 12,
  sm: 12,
  md: 12,
  lg: 8,
  xl: 6
}

const LocationRequestConfigForm = ({locations_request_config={}, inherited_locations_request_config={}, onSave=f=>f, onHeightChange=f=>f}) => {
  const { t } = useTranslation();
  const [onEdit, setOnEdit] = useState(false)
  const [isAndroid, setIsAndroid] = useState(locations_request_config.os == "android")
  const [showPromote, setshowPromote] = useState(inthertedValue(locations_request_config, inherited_locations_request_config,"ios_ask_mode") == "always")
  const [showUsePopup, setShowUsePopup] = useState(inthertedValue(locations_request_config, inherited_locations_request_config,"use_popup"))
  const initialValues = {
    app_id: '',
    publisher_id: '',
    ask_if_no_consent: '',
    ask_min_days: '',
    ask_min_launches: '',
    ios_ask_mode: '',
    ios_promote_min_days: '',
    ios_promote_min_launches: '',
    number_max_retry: '',
    popup_only_for_retry: '',
    retry_min_days: '',
    retry_min_days_settings: '',
    retry_min_launches: '',
    retry_min_launches_settings: '',
    use_popup: ''
  };
  const validationSchema = Yup.object().shape({
    app_id: Yup.number().allowEmptyString(),
    publisher_id: Yup.string(),
    ask_if_no_consent: Yup.boolean().allowEmptyString(),
    ask_min_days: Yup.number().allowEmptyString(),
    ask_min_launches: Yup.number().allowEmptyString(),
    ios_ask_mode: Yup.string().nullable(),
    ios_promote_min_days: Yup.number().allowEmptyString(),
    ios_promote_min_launches: Yup.number().allowEmptyString(),
    number_max_retry: Yup.number().allowEmptyString(),
    popup_only_for_retry: Yup.boolean().allowEmptyString(),
    retry_min_days: Yup.number().allowEmptyString(),
    retry_min_days_settings: Yup.number().allowEmptyString(),
    retry_min_launches: Yup.number().allowEmptyString(),
    retry_min_launches_settings: Yup.number().allowEmptyString(),
    use_popup: Yup.boolean().allowEmptyString(),
  })

  const { formData, setFormData, getInputProps, formProps, submitButtonProps } = useForm({
    defaultObject: locations_request_config,
    initialValues: initialValues,
    validationSchema: validationSchema,
    disabled: !onEdit,
    onSubmit: (data) => {
      onSave(data).then(()=>{
        setOnEdit(false)
      })
    },
  });

  useEffect(() => {
    setshowPromote(inthertedValue(formData, inherited_locations_request_config,"ios_ask_mode") == "always")
    setShowUsePopup(inthertedValue(formData, inherited_locations_request_config,"use_popup"))
  }, [formData])

  const cleanData = (obj) => (Object.keys(obj).reduce((accumulator, key) => {
    return {...accumulator, [key]: (accumulator[key] == null) ? '' : accumulator[key]};
  }, obj));

  useEffect(() => {
    setFormData(cleanData(locations_request_config))
    setIsAndroid(locations_request_config.os == "android")
  }, [locations_request_config]);

  useEffect(() => {
    onHeightChange()
  }, [showPromote, showUsePopup])

  const iosAskModeOptions = {
    "always": "Always",
    "when_in_use": "WhenInUse",
    "when_in_use_only_for_device_after_ios11": "WhenInUseOnlyForDeviceAfterIos11",
  }

  const onCancel = () => {
    setFormData(cleanData(locations_request_config))
    setOnEdit(false)
  }

  return (
    <Form {...formProps}>
      <FormGroup
        {...formGroupWidthProps}
        label={t("locationRequestConfig.askMinDays")}
        placeholder={`${inherited_locations_request_config.ask_min_days} (${t('locationRequestConfig.inherited')})`}
        input="number"
        {...getInputProps("ask_min_days")}/>
      <FormGroup
        {...formGroupWidthProps}
        label={t("locationRequestConfig.askMinLaunches")}
        placeholder={`${inherited_locations_request_config.ask_min_launches} (${t('locationRequestConfig.inherited')})`}
        input="number"
        {...getInputProps("ask_min_launches")}/>
      <FormGroup
        label={t("locationRequestConfig.askIfNoConsent")}
        placeholder={`${inherited_locations_request_config.ask_if_no_consent ? t("yes") : t("no") } (${t('locationRequestConfig.inherited')})`}
        {...getInputProps("ask_if_no_consent")}>
        <BoolSelect isClearable={true}/>
      </FormGroup>
      <FormGroup label={t("locationRequestConfig.iosAskMode")} {...getInputProps("ios_ask_mode")}>
        <Select
          isClearable={true}
          placeholder={`${iosAskModeOptions[inherited_locations_request_config.ios_ask_mode]} (${t('locationRequestConfig.inherited')})`}
          >
            { Object.keys(iosAskModeOptions).map((k) => (
              <Option key={k} value={k}>{iosAskModeOptions[k]}</Option>
            )) }
        </Select>
      </FormGroup>
      { showPromote && <>
          <FormGroup
            as={FormRowCol}
            xs={{ span: 11, offset: 1 }}
            label={t("locationRequestConfig.iosPromoteMinDays")}
            placeholder={`${inherited_locations_request_config.ios_promote_min_days} (${t('locationRequestConfig.inherited')})`}
            input="number"
            {...getInputProps("ios_promote_min_days")}/>
          <FormGroup
            as={FormRowCol}
            xs={{ span: 11, offset: 1 }}
            label={t("locationRequestConfig.iosPromoteMinLaunches")}
            placeholder={`${inherited_locations_request_config.ios_promote_min_launches} (${t('locationRequestConfig.inherited')})`}
            input="number"
            {...getInputProps("ios_promote_min_launches")}/>
        </>
      }
      { !isAndroid && <>
        <FormGroup
          label={t("locationRequestConfig.usePopup")}
          placeholder={`${inherited_locations_request_config.use_popup ? t("yes") : t("no") } (${t('locationRequestConfig.inherited')})`}
          {...getInputProps("use_popup")}>
          <BoolSelect isClearable={true}/>
        </FormGroup>
          { showUsePopup && <>
            <FormGroup
              as={FormRowCol}
              xs={{ span: 11, offset: 1 }}
              label={t("locationRequestConfig.popupOnlyForRetry")}
              placeholder={`${inherited_locations_request_config.popup_only_for_retry ? t("yes") : t("no") } (${t('locationRequestConfig.inherited')})`}
              {...getInputProps("popup_only_for_retry")} >
              <BoolSelect isClearable={true}/>
            </FormGroup>
            <FormGroup
              as={FormRowCol}
              xs={{ span: 11, offset: 1 }}
              label={t("locationRequestConfig.numberMaxRetry")}
              placeholder={`${inherited_locations_request_config.number_max_retry} (${t('locationRequestConfig.inherited')})`}
              input="number"
              {...getInputProps("number_max_retry")}/>
            <FormGroup
              as={FormRowCol}
              xs={{ span: 11, offset: 1 }}
              label={t("locationRequestConfig.retryMinDays")}
              placeholder={`${inherited_locations_request_config.retry_min_days} (${t('locationRequestConfig.inherited')})`}
              input="number"
              {...getInputProps("retry_min_days")}/>
            <FormGroup
              as={FormRowCol}
              xs={{ span: 11, offset: 1 }}
              label={t("locationRequestConfig.retryMinDaysSettings")}
              placeholder={`${inherited_locations_request_config.retry_min_days_settings} (${t('locationRequestConfig.inherited')})`}
              input="number"
              {...getInputProps("retry_min_days_settings")}/>
            <FormGroup
              as={FormRowCol}
              xs={{ span: 11, offset: 1 }}
              label={t("locationRequestConfig.retryMinLaunches")}
              placeholder={`${inherited_locations_request_config.retry_min_launches} (${t('locationRequestConfig.inherited')})`}
              input="number"
              {...getInputProps("retry_min_launches")}/>
            <FormGroup
              as={FormRowCol}
              xs={{ span: 11, offset: 1 }}
              label={t("locationRequestConfig.retryMinLaunchesSettings")}
              placeholder={`${inherited_locations_request_config.retry_min_launches_settings} (${t('locationRequestConfig.inherited')})`}
              input="number"
              {...getInputProps("retry_min_launches_settings")}/>
            </>
          }
      </>
      }
      { onEdit && <>
          <Button key="submit" type="submit" className="pull-right" variant="primary" {...submitButtonProps}>
            <Icon icon='save' text={t("save")} />
          </Button>
          <Button variant="secondary" className="pull-right" onClick={onCancel}>
            <Icon icon='cancel' text={t("cancel")}/>
          </Button>
        </> }
      { !onEdit && <>
        <Button variant="primary" className="pull-right" onClick={()=>(setOnEdit(true))}>
          <Icon icon='edit' text={t("edit")} />
        </Button>
      </> }
    </Form>
  )
}


export default LocationRequestConfigForm